module.exports = __webpack_public_path__ + "img/part-1-1.97e0fa5a.webp";